export default __webpack_public_path__ + "static/media/i-results.33fc84b7.svg";